module.exports = __webpack_public_path__ + "img/circle-info.7db3baf1.svg";